import { withRouter } from "react-router-dom";
import connexion from "./connexion"

export default withRouter(connexion);
